// @ts-nocheck
import { CHANGE_REQUEST_COMMENTS_ADD_REPLY_ERROR, CHANGE_REQUEST_COMMENTS_ADD_REPLY_LOADING, CHANGE_REQUEST_COMMENTS_ADD_REPLY_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ChangeRequestCommentsAddReplyReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_REQUEST_COMMENTS_ADD_REPLY_LOADING:
            return Object.assign({}, state, { loading: true })
        case CHANGE_REQUEST_COMMENTS_ADD_REPLY_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CHANGE_REQUEST_COMMENTS_ADD_REPLY_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

